import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Modal, Button } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";

const WarningModal = (props) => {
  const { isShow, setIsShow, noteUserId, homeEmail, setReloadData, routeName, onProceed } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setIsShow(false)
  }



  // console.log(selectedRow)
  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={isShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2">
                  <p><strong>Proceed?!</strong></p>
                  <p><strong>This action cannot be undone</strong>, are you sure you wish to proceed?!</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              onProceed()
            }}>
              Proceed
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default WarningModal